// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"correct"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20.9858 8.75736L15.5312 3.30273L7.28857 11.5454L12.7432 17L20.9858 8.75736Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7.2888 11.5454L3.16748 15.6667L8.6292 21.1284L12.7434 17M7.2888 11.5454L15.5314 3.30273L20.9861 8.75736L12.7434 17M7.2888 11.5454L12.7434 17","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21 17H19M21 21H14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-correct')
export default class CorrectIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'correct',
    }
  }
}
